const isFullUrl = (url: string): boolean => {
  return url.startsWith("http://") || url.startsWith("https://");
};

export default isFullUrl;
